import {
  PillsInputProps as MantinePillsInputProps,
  PillsInput as MantinePillsInput,
} from '@mantine/core';

export type PillsInputProps = MantinePillsInputProps;

export const PillsInput = MantinePillsInput;

PillsInput.displayName = 'PillsInput';
